module.exports = __webpack_public_path__ + "static/media/signOut.2e77aee5.svg";